// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* Flatten only the VFG root so schema App Shell keeps its flex box.\n   Lives here (not neu pack) so GS works when cssPacks.neu is off. */\n#bfapp > .vue-form-generator,\n#bfapp #bf-global-schema-layout > .vue-form-generator {\n  display: contents;\n}\n", ""]);
// Exports
module.exports = exports;
